export default __webpack_public_path__ + "static/media/plane-seat3.a06ed3cb.svg";